<div nz-row>
  <div nz-col [nzSpan]="24">
    <div class="form-title">{{ 'LOGIN_PAGE.SIGN_IN' | translate }}</div>
  </div>
</div>

<nz-spin
  class="mobiapp-spin login-spin"
  [nzSpinning]="login.authActionLoading$ | async"
  nzTip="{{ 'COMMON.LAYOUT.LOADING' | translate }}"
  nzSize="large"
  [nzIndicator]="indicatorTemplate">
  <form nz-form [formGroup]="login.loginForm" class="login-form" name="loginForm">
    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzRequired nzFor="loginEmail">
        {{ 'COMMON.LABEL.EMAIL' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <input
          #emailInput
          nz-input
          required
          id="loginEmail"
          name="loginEmail"
          type="email"
          formControlName="email"
          autocomplete="email"
          placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_EMAIL' | translate }}"
          (focus)="login.scrollToInput($event)"
          (keydown.enter)="login.onCredentialsEnter($event, 'email')"
          [attr.aria-describedby]="
            login.loginForm.controls.email.invalid && login.loginForm.controls.email.touched ? 'emailError' : null
          "
          [attr.aria-invalid]="login.loginForm.controls.email.invalid ? 'true' : null" />
      </nz-form-control>
      @if (login.loginForm.controls.email.invalid && login.loginForm.controls.email.touched) {
        <mat-error id="emailError">
          {{ login.loginForm.controls.email.errors | errorsFormatingAndTranslate }}
        </mat-error>
      }
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzRequired nzFor="loginPassword">
        {{ 'COMMON.LABEL.PASSWORD' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-input-password [nzVisibilityToggle]="true">
          <input
            #passwordInput
            nz-input
            required
            id="loginPassword"
            name="loginPassword"
            formControlName="password"
            autocomplete="current-password"
            placeholder="{{ 'COMMON.PLACEHOLDER.ENTER_PASSWORD' | translate }}"
            (focus)="login.scrollToInput($event)"
            (keydown.enter)="login.onCredentialsEnter($event, 'password')"
            [attr.aria-describedby]="
              login.loginForm.controls.password.invalid && login.loginForm.controls.password.touched
                ? 'passwordError'
                : null
            "
            [attr.aria-invalid]="login.loginForm.controls.password.invalid ? 'true' : null" />
        </nz-input-password>
      </nz-form-control>
      @if (login.loginForm.controls.password.invalid && login.loginForm.controls.password.touched) {
        <mat-error id="passwordError">
          {{ login.loginForm.controls.password.errors | errorsFormatingAndTranslate }}
        </mat-error>
      }
    </nz-form-item>
  </form>

  <div nz-row>
    <div nz-col [nzSpan]="24">
      <button
        (click)="login.submitLoginForm()"
        class="submit-button"
        [disabled]="
          login.loginForm.pristine ||
          (login.loginForm.dirty && login.loginForm.invalid) ||
          (login.authActionLoading$ | async)
        "
        mat-raised-button
        color="primary">
        {{ 'LOGIN_PAGE.SIGN_IN' | translate }}
      </button>
    </div>
  </div>

  @if (login.errorMessage$ | async; as errorMessage) {
    <div class="error-message-container" role="alert">
      <p>{{ errorMessage | translate }}</p>
    </div>
  }

  <div nz-row>
    <div nz-col [nzSpan]="24">
      <div class="reset-password-link">
        <a (click)="$event.preventDefault()" [routerLink]="['/reset-password']">
          {{ 'LOGIN_PAGE.RESET_PASSWORD' | translate }}
        </a>
      </div>
    </div>
  </div>
</nz-spin>

<ng-template #indicatorTemplate>
  <span nz-icon nzType="loading" class="ant-spin-dot"></span>
</ng-template>
